<template>
    <b-row class="mb-5">
        <b-col>
            <b-table 
                :items="items" 
                :fields="fields" 
                selectable
                select-mode="single"
                id="customer-dashboard"
                @row-selected="update_sensor"
                primary-key="id"
                ref="selectableTable"
            >

                <template v-slot:cell(device_status)="item">
                    <div v-if="item.value == 'GREEN'" class="ring-container">
                        <div class="ringing"></div>
                        <div class="circle"></div>
                    </div>

                    <div v-else-if="item.item.scheduled_maintenance" class="ring-container">
                        <div class="ringing ringing-yellow"></div>
                        <div class="circle circle-yellow"></div>
                    </div>

                    <div v-else class="ring-container">
                        <div class="ringing ringing-red"></div>
                        <div class="circle circle-red"></div>
                    </div>
                </template>

                <template v-slot:cell(details)="item">
                    <span style="margin-left:12px">
                        <router-link :to="`/device/${item.item.device_id}`">
                            <img src="/icons/icon-details.png" height="24">
                        </router-link>
                    </span>
                </template>

                <template v-slot:cell(installation_date)="item">
                    {{ item.value | capitalize }}
                </template>

              <template v-slot:cell(last_report_date)="item">
                  <span>
                    {{ item.value | formatDateTime}}
                  </span>
              </template>

              <template v-slot:cell(last_alert_date)="item">
                  <span>
                    {{ item.value | formatDateTime}}
                  </span>
              </template>

              <template v-slot:cell(last_alert)="item">
                    <router-link v-if="item.value" 
                        :to="`/device/alerts/${item.item.device_id}`"
                        :id="`alert-${tableName}-${item.item.device_id}`"
                    > {{ item.value | capitalize }} </router-link>
                </template>

                <template v-slot:cell(scheduled_maintenance)="item">
                    <router-link v-if="item.value" 
                        :to="`/device/maintenance/${item.item.device_id}/${item.item.maintenance_id}`"
                        :id="`maintenance-${tableName}-${item.item.device_id}`"
                    >
                        {{ item.value | capitalize }}
                    </router-link>
                    <router-link  v-else 
                        :to="`/home`"
                    > Request Maintenance </router-link>
                </template>

                <template v-slot:cell(service_plan_name)="item">
                    <p style="margin-bottom:0px">{{item.value}}</p>
                </template>

            </b-table>
        </b-col>
    </b-row>
</template>

<script>
    import { get_dashboard } from '../../networking/account'
    import moment from 'moment'

    const fields = [
        { key: 'device_status', label:'Status', sortable: false, tdClass: 'status-cell' },
        { key: 'device_name', label: 'Device Name', sortable: false, class:'device-name' },
        { key: 'sensor_name', label: 'Sensor Name', sortable: false, class:'device-name' },
        { key: 'sensor_type_desc', label: 'Sensor Type', sortable: false, class:"d-none d-md-table-cell" },
        { key: 'podid', label: 'SensorID', sortable: false },
        { key: 'last_report_date', label: 'Last Report'},
        { key: 'last_alert_date', label: 'Last Alert'},
        // {
        //     key: 'last_alert_date', label: 'Last Alert', sortable: false, class:"d-none d-md-table-cell",
        //     formatter: value => value ? moment(value).fromNow() : null
        // },
        { key: 'details', label: 'Details', },
    ]

    export default {

        props:{
            userData:{ type: Object, required: true },
        },

        data(){
            return {
                ids: [{ name: 'device_type', id:'device_id', to:'device' }],
                fields: fields,
                items: [],
                tableName: 'dealer-dashboard',
                selected: 0
            }
        },

        async created(){
            await this.retrieve_dashboard_table();
            this.$refs.selectableTable.selectRow(0)
        },
        methods:{
            async retrieve_dashboard_table(){
                const generator = get_dashboard(this.userData.accountId)
                const { value: { alert, data = [] }} = await generator.next()
                this.items = data.map((item, i) => ({ ...item, id:i}))
                //this.update_sensor(this.selected)
            },
            update_sensor(items){this.$emit('update_sensor', items[0])}
        },

        filters: {
            capitalize: value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : ''
        }        
    }

</script>


<style scoped>

    .ring-container {
        position: relative;
    }

    .circle {
        width: 15px;
        height: 15px;
        background-color: #62bd19;
        border-radius: 50%;
        position: absolute;
        top: 10px;
        left: 20px;
    }

    .ringing {
        border: 3px solid #62bd19;
        border-radius: 30px;
        height: 25px;
        width: 25px;
        position: absolute;
        left: 15px;
        top: 5px;
        animation: pulsate 4.2s ease-out;
        animation-iteration-count: infinite; 
        opacity: 0.0
    }

    .circle-red{ background-color:  #b71400 }
    .ringing-red{ border: 3px solid #b71400 }
    .circle-yellow{ background-color: goldenrod }
    .ringing-yellow{ border: 3px solid goldenrod }


    @keyframes pulsate {
        0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
        50% {opacity: 1.0;}
        100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
    }

    .status-cell { width: 100px }
    .logo-cell { 
        padding-left: 24px!important;
        padding-right: 0px!important 
    }

    th[role=columnheader] { vertical-align: middle!important }
    td[role=cell] { vertical-align: middle!important }

</style>
